import { getGlobals, getArchive } from "storyblok/api"
import { getAllArchiveVideoCategories, getCategoryArchiveVideos } from "storyblok/videoLibrary"
import Meta from "components/Meta"
import VideoCard from "components/VideoCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import { getCategoryArchiveVideosApi } from "storyblok/videoLibraryApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function VideoArchive({ meta, items, categories, story, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-body>
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Video Library", href: "/video-library" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/video-library"
          categoryLinkPrefix="/video-library/category/"
          currentTab={{ name: "All", value: "all" }}
          list={
            <CardListSection
              key="all"
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              columns={3}
              handler={(params) => getCategoryArchiveVideosApi(params)}
              Card={VideoCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  const story = await getArchive("video-library", preview)
  const categories = await getAllArchiveVideoCategories()
  const { items, currentPage, total, perPage } = await getCategoryArchiveVideos()

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      items: items ?? null,
      perPage,
      total,
      currentPage,
      categories: categories ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
